export const NON_WORKING_DAY_CREATE_EDIT = "NON_WORKING_DAY_CREATE_EDIT";
export const NON_WORKING_DAY_CREATE_EDIT_SUCCESS = "NON_WORKING_DAY_CREATE_EDIT_SUCCESS";
export const NON_WORKING_DAY_CREATE_EDIT_ERROR = "NON_WORKING_DAY_CREATE_EDIT_ERROR";
export const NON_WORKING_DAY_DETAILS = "NON_WORKING_DAY_DETAILS";
export const NON_WORKING_DAY_DETAILS_SUCCESS = "NON_WORKING_DAY_DETAILS_SUCCESS";
export const NON_WORKING_DAY_DETAILS_ERROR = "NON_WORKING_DAY_DETAILS_ERROR";
export const NON_WORKING_DAY_DELETE = "NON_WORKING_DAY_DELETE";
export const NON_WORKING_DAY_DELETE_SUCCESS = "NON_WORKING_DAY_DELETE_SUCCESS";
export const NON_WORKING_DAY_DELETE_ERROR = "NON_WORKING_DAY_DELETE_ERROR";
export const NON_WORKING_DAYS_LIST = "NON_WORKING_DAYS_LIST";
export const NON_WORKING_DAYS_LIST_SUCCESS = "NON_WORKING_DAYS_LIST_SUCCESS";
export const NON_WORKING_DAYS_LIST_ERROR = "NON_WORKING_DAYS_LIST_ERROR";